module.exports = __webpack_public_path__ + "img/4.549a6353.jpg";